module.exports = __webpack_public_path__ + "static/media/SP_features_mobile.d7489474.png";